<template>
    <v-card class="default_card_wm elevation-0 px-4 py-3 mb-2">
        <v-row no-gutters>
            <v-col cols="12" class="d-flex align-center">
                <v-btn-icon
                    @click="showData = !showData"
                    :icon="showData ? '$fa-chevron-up' : '$fa-chevron-down'"
                />
                <h3 class="ml-4">Informations déclarant</h3>
            </v-col>
        </v-row>
        <template v-if="showData">
            <v-row no-gutters class="px-1 py-1">
                <v-col cols="3" class="px-1">
                    <v-text-field-filled
                        v-model="declaring.companyName"
                        label="Raison sociale"
                        outlined
                        hide-details="auto"
                        density="compact"
                        disabled
                    />
                </v-col>
                <v-col cols="3" class="px-1">
                    <v-text-field-filled
                        v-model="declaring.siret"
                        label="SIRET"
                        @input="onInputSetTruncatedSiret()"
                        outlined
                        hide-details="auto"
                        density="compact"
                        disabled
                    />
                </v-col>
                <v-col cols="3" class="px-1">
                    <v-text-field-filled
                        v-model="declaring.ape"
                        label="Code APE"
                        outlined
                        hide-details="auto"
                        density="compact"
                        disabled
                    />
                </v-col>
                <v-col cols="3" class="px-1">
                    <v-text-field-filled
                        v-model="declaring.closingDate"
                        label="Date de clôture de l'exercice (format JJMM)"
                        outlined
                        hide-details="auto"
                        density="compact"
                        disabled
                    />
                </v-col>
            </v-row>
            <v-row no-gutters class="px-1 py-1">
                <v-col cols="1" class="px-1">
                    <v-text-field-filled
                        v-model="declaring.number"
                        label="Numéro"
                        outlined
                        hide-details="auto"
                        density="compact"
                    />
                </v-col>
                <v-col cols="1" class="px-1">
                    <v-text-field-filled
                        v-model="declaring.btq"
                        label="BTQ"
                        outlined
                        hide-details="auto"
                        density="compact"
                    />
                </v-col>
                <v-col cols="3" class="px-1">
                    <v-text-field-filled
                        v-model="declaring.street"
                        label="Voie"
                        outlined
                        hide-details="auto"
                        density="compact"
                    />
                </v-col>
                <v-col cols="2" class="px-1">
                    <v-text-field-filled
                        v-model="declaring.city"
                        label="Commune"
                        outlined
                        hide-details="auto"
                        density="compact"
                        @update:modelValue="onPostalCodeOrCityChange(declaring)"
                    />
                </v-col>
                <v-col cols="1" class="px-1">
                    <v-text-field-filled
                        v-model="declaring.postalCode"
                        label="Code postal"
                        outlined
                        hide-details="auto"
                        density="compact"
                        @update:modelValue="onPostalCodeOrCityChange(declaring)"
                    />
                </v-col>
                <v-col cols="2" class="px-1">
                    <v-text-field-filled
                        v-model="declaring.inseeCode"
                        label="Code Insee commune"
                        outlined
                        hide-details="auto"
                        density="compact"
                    />
                </v-col>
                <v-col cols="2" class="px-1">
                    <v-text-field-filled
                        v-model="declaring.postOfficeDistributor"
                        label="Bureau distributeur"
                        outlined
                        hide-details="auto"
                        density="compact"
                    />
                </v-col>
            </v-row>
            <v-row no-gutters class="px-1 py-1">
                <v-col cols="4" class="px-1">
                    <v-text-field-filled
                        v-model="declaring.signatoryName"
                        label="Personne à contacter"
                        outlined
                        hide-details="auto"
                        density="compact"
                    />
                </v-col>
                <v-col cols="4" class="px-1">
                    <v-text-field-filled
                        v-model="declaring.signatoryEmail"
                        label="Adresse mail"
                        outlined
                        hide-details="auto"
                        density="compact"
                    />
                </v-col>
                <v-col cols="4" class="px-1">
                    <v-text-field-filled
                        v-model="declaring.signatoryPhone"
                        label="Téléphone"
                        outlined
                        hide-details="auto"
                        density="compact"
                    />
                </v-col>
            </v-row>
        </template>
    </v-card>
</template>

<script lang="ts">
import { Component, Vue, toNative, Prop } from "vue-facing-decorator";
import { DasTwoDeclaring } from "@/services/declaration/declarationServices";
import { truncateInput } from "@/helpers/formInput.helper";

@Component({})
export class DasTwoDeclaringCard extends Vue {
    @Prop({ default: null }) declaring: DasTwoDeclaring;
    showData: boolean = true;

    onInputSetTruncatedSiret() {
        this.declaring.siret = truncateInput(this.declaring.siret, 14);
    }

    async onPostalCodeOrCityChange(declaring: DasTwoDeclaring) {
        await declaring.getCityInseeCode();
    }
}

export default toNative(DasTwoDeclaringCard);
</script>
